<template>
  <div class="truemed-widget">
    <div
      id="truemed-instructions"
      data-public-id="tm_qual_cg7ybp2zmq"
    />
  </div>
</template>

<style lang="scss">
// More details about !important for the Truemed Widget can be found here:
// https://support.truemed.com/en/articles/2474177

// Scope the global styles to the new widget to prevent any unintended consequences on the old widget
// Using :not() pseudo-class to scope the styles instead of scoped styles because the Truemed Widget injects its own styles into the DOM that cannot be scoped
.truemed-widget:not(.truemed-widget--old) {
  margin-bottom: 0.125rem; // 2px margin below the widget for spacing

  /* stylelint-disable declaration-no-important */
  .truemed-instructions-header-garmin-logo {
    height: 3rem !important;

    @include breakpoint(sm) {
      height: 3.5rem !important;
    }
  }

  .truemed-instructions-header-logo {
    height: 1rem !important;

    @include breakpoint(sm) {
      height: 1.5rem !important;
    }
  }

  .truemed-logo-img {
    height: 0.688rem !important;
  }

  .truemed-instructions {
    font-family: $font-superscripts-roboto, $font-roboto, $font-noto, $font-fallback-sans-serif !important;
    font-size: $font-size-small !important;
  }

  .truemed-instructions-open {
    font-size: $font-size-tiny !important;
    color: $color-black !important;
  }

  .truemed-instructions-link-text {
    font-family: $font-superscripts-roboto, $font-roboto, $font-noto, $font-fallback-sans-serif !important;
    justify-content: left !important;
  }
}
/* stylelint-enable declaration-no-important */
</style>
